
import md5 from 'js-md5'
export let Tools = {
	trim: function (str) {
		return String(str).replace(/^\s*|\s*$/g, '')
	},
	isEmpty: function (str) {
		return this.trim(str) === '';
	},
	isUsername: function (str) {
		return /^[a-zA-Z]+[a-zA-Z0-9_]*$/.test(str);
	},
	isPassword: function (str) {
		return /^[a-zA-Z0-9]+$/.test(str);
	},
	hasCn: function (str) {
		return /^[\u4e00-\u9fa5]+$/.test(str);
	},
	numBegin: function (str) {
		return /^\d+.*/.test(str);
	},
	isMobile: function (str) {
		return /^((13[0-9])|(1[46789][0-9])|(15[^4\D]))\d{8}$/.test(str);
	},
	isHKMobile: function (str) {
		return /^[0-9]{8}$/.test(str);
	},
	//新加代码：注册页面 对土耳其手机号的校验。
	isTkMobile: function (str) {
		return /^[0-9]{10}$/.test(str);
	},

	isEmail: function (str) {
		return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(str);
	}
}
/*主要是迷惑作用不参加真实运算token */
var false_token = "6ecf24d8884f99dd"
export let getToken = function (username, tnow) {
	var getRealToken = function () {
		var result = false_token + '/merchant/register/chklev1.do';
		return md5(result.match(/.*\/(.*?)\.do/)[1]);
	},

		fnFillData = function (retArr, arr, st, ed) {
			for (var i = st; i < ed; i++)
				retArr.push(arr[i])
		},
		arrToken = getRealToken().split(''),
		arrName = username.split(''),
		arrNow = (tnow + '').split(''),
		len1 = 8,
		len2 = arrName.length,
		len3 = arrNow.length,
		len = len1 + len2 + len3,
		ret = [],
		count = 0;
	fnFillData(ret, arrToken, 0, 2 * len1)
	fnFillData(ret, arrName, 0, len2)
	fnFillData(ret, arrToken, 2 * len1, 3 * len1)
	fnFillData(ret, arrNow, 0, len3)
	fnFillData(ret, arrToken, 3 * len1, 4 * len1)
	return md5(ret.join(''))
}

export let countryList = [{
	'name': '中国大陆',
	'enname': 'Chinese Mainland',
	'areacode': '+86',
	'countrycode': 'CN'
}, {
	'name': '中国香港',
	'enname': 'Hong Kong, China',
	'areacode': '+852',
	'countrycode': 'HK'
}, {
	'name': '美国',
	'enname': 'America',
	'areacode': '+1',
	'countrycode': 'US'
}, {
	'name': '加拿大',
	'enname': 'Canada',
	'areacode': '+1',
	'countrycode': 'CA'
}, {
	'name': '法国',
	'enname': 'France',
	'areacode': '+33',
	'countrycode': 'FR'
}, {
	'name': '德国',
	'enname': 'Germany',
	'areacode': '+49',
	'countrycode': 'DE'
}, {
	'name': '意大利',
	'enname': 'Italy',
	'areacode': '+39',
	'countrycode': 'IT'
}, {
	'name': '韩国',
	'enname': 'Korea',
	'areacode': '+82',
	'countrycode': 'KR'
}, {
	'name': '荷兰',
	'enname': 'Netherlands',
	'areacode': '+31',
	'countrycode': 'NL'
}, {
	'name': '巴布亚新几内亚',
	'enname': 'Papua New Guinea',
	'areacode': '+675',
	'countrycode': 'PG'
}, {
	'name': '波兰',
	'enname': 'Poland',
	'areacode': '+48',
	'countrycode': 'PL'
}, {
	'name': '俄罗斯',
	'enname': 'Russia',
	'areacode': '+7',
	'countrycode': 'RU'
}, {
	'name': '西班牙',
	'enname': 'Spain',
	'areacode': '+34',
	'countrycode': 'ES'
}, {
	'name': '瑞典',
	'enname': 'Sweden',
	'areacode': '+46',
	'countrycode': 'SE'
}, {
	'name': '土耳其',
	'enname': 'Turkey',
	'areacode': '+90',
	'countrycode': 'TR'
}, {
	'name': '英国',
	'enname': 'United Kindom',
	'areacode': '+44',
	'countrycode': 'UK'
}]

export let validateMobile = function (type, val) { //type国家区号 val手机号
	var areanum = type,
		patn = new RegExp("^((4)|(5)|(6)|(8)|(9)){7}$"), //香港 
		tb = {
			"CN": /^((13[0-9])|(1[46789][0-9])|(15[^4\D]))\d{8}$/, //大陆
			"HK": /^((4)|(5)|(8)|(6)|(9))\d{7}$/, //中国香港
			"US": /^\d{10}$/, //美国 
			"CA": new RegExp("^[0-9]{5,10}$"), //加拿大
			"FR": /^(\d{9}|\d{10})$/, //法国
			"DE": new RegExp("^[0-9]{9,11}$"), //德国
			"IT": new RegExp("^[0-9]{9,11}$"), //意大利
			"KR": new RegExp("^[0-9]{9,11}$"), //韩国
			"NL": /^(\d{9}|\d{10})$/, //荷兰
			"PG": new RegExp("^[0-9]{5,16}$"), //巴布亚新几内亚
			"PL": /^(\d{9}|\d{10})$/, //波兰
			"RU": new RegExp("^[0-9]{5,16}$"), //俄罗斯
			"ES": /^(\d{9}|\d{10})$/, //西班牙
			"SE": new RegExp("^[0-9]{5,16}$"), //瑞典
			"TR": new RegExp("^[0-9]{5,16}$"), //土耳其
			"UK":  /^(\d{1}|\d{10})$/, //英国
		};
	patn = tb[areanum] || patn;
	return patn.test(val);
}
export let validateEmail = function (val) {
	var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
	if (val) {
		if (!emailReg.test(val)) {
			return false
		} else {
			return true
		}
	}
	return false
}

export let getCookie = function (name) {
	var strcookie = document.cookie; //获取cookie字符串
	var arrcookie = strcookie.split("; "); //分割
	var lang1 = '',
		lang2 = '',
		flag = false;
	//遍历匹配
	for (var i = 0; i < arrcookie.length; i++) {
		var arr = arrcookie[i].split("=");
		if (arr[0] == name) {
			flag = true
			lang1 = arr[1].split('_').join('-');
		} else {
			lang2 = 'zh-CN'
		}
	}
	return flag ? lang1 : lang2
	// return 'en-US'
}
export let setCookie = function(name,value){
	var day = day || 365,
			expires = new Date(),
			domain = '.dhgate.com';
	expires.setTime((new Date()).getTime() + 3600 * 24 * 1000 * day);
	return document.cookie=name+'='+escape(value)+ "; path=/; domain=" + domain + (day == -1 ? '' : ";expires=" + expires.toGMTString());
}
export let debounce = function (fn, timeout) {
	var timer
	return function (e) {
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			fn.apply(this, [e])
		}, timeout)
	}
}

export let randomCoding = function(){
	//创建26个字母数组
	var arr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
	var idvalue ='';
	var n = 1;//这个值可以改变的，对应的生成多少个字母，根据自己需求所改
	for(var i=0;i<n;i++){
	   idvalue+=arr[Math.floor(Math.random()*26)];
	}
	return idvalue;
}
export let randomCoding2 = function(){
	var ans = '', arr='1234567890qwertyuiopasdfghjklzxcvbnm';
	for(var i = 1; i > 0; i--) {
		ans +=arr[Math.floor(Math.random() * arr.length)];
	}
	return ans;
}

export let randomStr = function(len){
	var ans = '', arr='************************';
	for(var i = len; i > 0; i--) {
		ans +=arr[Math.floor(Math.random() * arr.length)];
	}
	return ans;
}